import { render, staticRenderFns } from "./freightInquiryDetail.vue?vue&type=template&id=47d0781c&scoped=true"
import script from "./freightInquiryDetail.vue?vue&type=script&lang=js"
export * from "./freightInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./freightInquiryDetail.vue?vue&type=style&index=0&id=47d0781c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d0781c",
  null
  
)

export default component.exports